import {Typography, useReachGoalCallback} from '@logistics-frontend/blocks'
import {PropsWithClasses} from '@logistics-frontend/blocks/theme/UNSTABLE_makeStyles'
import React, {useCallback, useContext, useEffect} from 'react'

import {lang} from 'src/i18n'
import {SharedRoutePageContext} from 'src/pages/route/context'
import {Brand} from 'src/pages/route/types'

import {Drawer, DrawerSection} from '../../drawer'
import {Props as BaseProps} from '../types'
import {ClassKey, useClasses} from './Postcard.classes'
import YandexEnLogo from './YandexEnLogo'
import YandexPromoButton from './YandexPromoButton'
import YandexRuLogo from './YandexRuLogo'
import YangoLogo from './YangoLogo'
import YangoPromoButton from './YangoPromoButton'

type Props = PropsWithClasses<ClassKey> & BaseProps

const Postcard = React.forwardRef<HTMLDivElement, Props>(({data, classes: classesProp}, ref) => {
  const classes = useClasses(classesProp)
  const reachGoal = useReachGoalCallback()
  const clickHandler = useCallback(() => reachGoal('TeaserInstallButtonClicked'), [reachGoal])
  const {brand} = useContext(SharedRoutePageContext)
  const AppLogo = brand === Brand.Yango ? YangoLogo : lang === 'ru' ? YandexRuLogo : YandexEnLogo
  const PromoButtonComponent = brand === Brand.Yandex ? YandexPromoButton : YangoPromoButton

  useEffect(() => {
    reachGoal('TeaserShown')

    return () => reachGoal('TeaserClosed')
  }, [reachGoal])

  return (
    <Drawer ref={ref} className={classes.root}>
      <DrawerSection fullHeight>
        <div className={classes.postcard} style={{backgroundImage: `url(${data.content.url})`}}>
          <div className={classes.postcardFooter}>
            <AppLogo color="white" />
            <Typography className={classes.summary} group="tight" thickness="medium" variant="body2">
              {data.summary_postcard}
            </Typography>
          </div>
        </div>
        <div className={classes.buttonRoot}>
          <PromoButtonComponent onClick={clickHandler} />
        </div>
      </DrawerSection>
    </Drawer>
  )
})

export default Postcard
